import { render, staticRenderFns } from "./ApplySuccess.vue?vue&type=template&id=0c65cf0c&scoped=true&"
import script from "./ApplySuccess.vue?vue&type=script&lang=js&"
export * from "./ApplySuccess.vue?vue&type=script&lang=js&"
import style0 from "./ApplySuccess.vue?vue&type=style&index=0&id=0c65cf0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65cf0c",
  null
  
)

export default component.exports